import React from 'react';

import './styles/TickerFrame.scss';

export default (props) => {
  return (
    <React.Fragment>
      <div className="TickerFrame TickerFrame--top"></div>
      <div className="TickerFrame TickerFrame--bottom"></div>
      <div className="TickerFrame TickerFrame--left"></div>
      <div className="TickerFrame TickerFrame--right"></div>
    </React.Fragment>
  )
}